import { render } from "./SuperMenu.vue?vue&type=template&id=70677586&scoped=true"
import script from "./SuperMenu.vue?vue&type=script&lang=js"
export * from "./SuperMenu.vue?vue&type=script&lang=js"

import "./SuperMenu.vue?vue&type=style&index=0&id=70677586&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70677586"]])

export default __exports__